import { Injectable } from '@angular/core';
import { StatusReason } from '@shared/constants/status-reason';
import { statusTypes } from '@shared/constants/status-types';
import { IBaseDeviceStatus } from '@shared/interfaces/base-device-status.interface';

@Injectable({ providedIn: 'root' })
export class DeviceStatusService {
  constructor() { }

  public checkReason<T extends IBaseDeviceStatus>(data: T, statusType: statusTypes, reasons: StatusReason | StatusReason[]): boolean {
    const table = reasons instanceof Array ? reasons : [ reasons ];
    return data.statusCode === statusType && data.reason !== undefined && table.includes(data.reason);
  }
}
